import { Router } from "react-router-dom";

import { StoreProvider, RouterProvider } from "@context";

import Error from "../../components/common/error/error/Error";
import {
  GlobalLoadingIndicator,
  MultiProvider,
  Toastr,
} from "../../shared/components";
import { isSupported } from "../../shared/services/browserSupport";
import history from "../../shared/services/history";
import Message from "../../shared/services/message";

/**
 * Container and route setting
 */
import AppRoutes from "./AppRoutes";

/**
 * Page component
 */
function App() {
  return (
    <Router history={history}>
      <div className="code-app">
        {isSupported ? (
          <MultiProvider
            providers={[
              <StoreProvider key="StoreContextProvider" />,
              <RouterProvider key="RouterContextProvider" />,
            ]}
          >
            <AppRoutes />
          </MultiProvider>
        ) : (
          <Error
            location={{
              state: {
                error: Message.getMessageByKey("message.unsupportedBrowser"),
                description: Message.getMessageByKey(
                  "message.unsupportedBrowserDescription",
                ),
              },
            }}
            hasBackButton={false}
          />
        )}
        <Toastr />
        <GlobalLoadingIndicator />
      </div>
    </Router>
  );
}

export default App;
